<template>
  <div class="partMeeting-container">
    <van-sticky>
      <head-bar
        type="primary"
        :leftArrow="true"
        left-text=""
        title="照片直播"
        @onClickLeft="onClickLeft"
      />
    </van-sticky>
    <div class="main">
      <div v-if="loading" class="skeleton-list" aria-label="正在加载照片直播">
        <div v-for="item in 3" :key="item" class="skeleton-card">
          <div class="skeleton-title shimmer"></div>
          <div class="skeleton-meta">
            <span class="shimmer"></span>
            <span class="shimmer"></span>
            <span class="shimmer"></span>
          </div>
        </div>
      </div>
      <div v-else-if="list.length === 0" class="state-card">暂无照片直播安排</div>
      <article
        v-else
        v-for="(item, index) in list"
        :key="item.id || item.groupLink || index"
        class="photo-card"
        :class="{
          'photo-card-clickable': item.pLiveUrl || item.pliveUrl,
          'opening-card': isOpening(item)
        }"
        @click="goLive(item.pLiveUrl || item.pliveUrl)"
      >
        <div class="card-content">
          <h2>{{ item.name || '分会场' }}</h2>
          <div class="card-meta">
            <div class="card-meta-top">
              <span class="card-time"><van-icon name="clock-o" />{{ formatDate(item) }}</span>
              <span class="card-entry">
                <van-icon name="play-circle-o" />
                {{ item.pLiveUrl || item.pliveUrl ? '点击进入' : '即将开放' }}
              </span>
            </div>
            <div class="card-address">
              <van-icon name="location-o" />
              <span>{{ item.address || '地点待定' }}</span>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import headBar from "@/components/headBar/headBar";
import { Dialog, Toast } from "vant";
import webConfig from '@/config'
export default {
  components: { headBar },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  mounted() {
    this.getLiveList();
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index/" + this.$store.state.miceInfo.miceLink);
    },
    async getLiveList() {
      this.loading = true;
      let result = await this.$http.get(
        this.$baseURL.index.getGroupList() +
          "?miceLink=" +
          this.$store.state.miceInfo.miceLink,
        1
      );
      if (result.code === 200) {
        this.list = (result.data || []).filter(item => item.display === 1);
      } else {
        Dialog.alert({
          title: "提示",
          message: result.message,
        }).then(() => {
          // on close
        });
      }
      this.loading = false;
    },
    formatDate(item) {
      const startDate = item.startDate || '';
      const endDate = item.endDate || startDate;
      const startTime = item.startTime ? item.startTime.substr(0, 5) : '';
      const endTime = item.endTime ? item.endTime.substr(0, 5) : '';
      const date = startDate && endDate && startDate !== endDate
        ? `${startDate.substr(5)}-${endDate.substr(5)}`
        : (startDate ? startDate.substr(5) : '时间待定');
      return `${date}${startTime && endTime ? ` ${startTime}-${endTime}` : ''}`;
    },
    isOpening(item) {
      return /开幕式/.test(item.name || '');
    },
    goLive(url) {
      if (url) {
        window.location.href = url;
      } else {
        Toast(webConfig.messages.comingSoonWithPunctuation);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.partMeeting-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  color: #fff;
  background: #0636cf;
}
.partMeeting-container .main { flex: 1; padding: 18px 16px 30px; overflow-y: auto; }
.photo-card {
  position: relative;
  min-height: 126px;
  max-width: 650px;
  margin: 0 auto 14px;
  overflow: hidden;
  border-radius: 12px;
  background-image:
    linear-gradient(90deg, rgba(8, 21, 155, .45), rgba(0, 40, 187, .12)),
    url("https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202609050028528001380.jpg ");
  background-position: center;
  background-size: cover;
  box-shadow: 0 6px 14px rgba(0, 24, 121, .26);
}
.photo-card::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';
  pointer-events: none;
  background: linear-gradient(100deg, transparent 42%, rgba(103, 238, 255, .13) 52%, transparent 62%);
}
.photo-card-clickable { cursor: pointer; }
.photo-card-clickable:active { transform: scale(.985); }
.opening-card { min-height: 184px; }
.opening-card .card-content { min-height: 184px; padding-top: 28px; padding-bottom: 28px; }
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 126px;
  padding: 16px 18px;
  background: linear-gradient(180deg, rgba(4, 20, 130, .02), rgba(4, 23, 150, .25));
}
.card-content h2 {
  position: relative;
  z-index: 1;
  display: table;
  margin: 0 auto 14px;
  padding: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 1px;
  text-shadow: 1px 2px 0 #1365ba, 0 0 8px rgba(116, 237, 255, .5), 0 3px 7px rgba(0, 7, 97, .75);
}
.opening-card .card-content h2 {
  font-size: 30px;
  letter-spacing: 3px;
  color: #ffffff;
  text-shadow: 2px 2px 0 #136bca, 0 0 10px rgba(105, 239, 255, .78), 0 4px 9px rgba(0, 7, 97, .78);
}
.card-content h2::after {
  display: block;
  width: 38px;
  height: 2px;
  margin: 8px auto 0;
  content: '';
  background: linear-gradient(90deg, transparent, #8df5ff, transparent);
}
.opening-card .card-content h2::after {
  width: 56px;
}
.card-meta {
  position: relative;
  z-index: 1;
  font-size: 11px;
  color: rgba(246, 252, 255, .96);
}
.card-meta-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-bottom: 7px;
  white-space: nowrap;
}
.card-meta span,
.card-entry,
.card-address { display: inline-flex; align-items: center; }
.card-meta .van-icon { flex: none; margin-right: 4px; font-size: 13px; color: #b9f8ff; }
.card-entry { flex: none; color: #a7f7ff; font-weight: 600; }
.card-entry .van-icon { margin-right: 3px; }
.card-address {
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  color: rgba(246, 252, 255, .94);
  line-height: 1.45;
  text-align: center;
}
.card-address .van-icon { margin-top: 1px; }
.card-address span {
  display: block;
  flex: 0 1 auto;
  max-width: calc(100% - 20px);
  min-width: 0;
  word-break: break-all;
}
.skeleton-list { max-width: 650px; margin: 0 auto; }
.skeleton-card {
  position: relative;
  height: 126px;
  margin-bottom: 14px;
  overflow: hidden;
  border-radius: 12px;
  background:
    linear-gradient(90deg, rgba(17, 47, 179, .92), rgba(23, 71, 210, .86)),
    url("https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202609050028528001380.jpg") center / cover;
  box-shadow: 0 6px 14px rgba(0, 24, 121, .2);
}
.skeleton-card::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: '';
  background: rgba(4, 29, 145, .42);
}
.skeleton-title,
.skeleton-meta { position: relative; z-index: 1; }
.skeleton-title {
  width: 46%;
  height: 24px;
  margin: 33px auto 18px;
  border-radius: 6px;
}
.skeleton-meta { display: flex; justify-content: center; gap: 12px; }
.skeleton-meta span { width: 24%; height: 11px; border-radius: 99px; }
.shimmer {
  background: linear-gradient(100deg, rgba(130, 215, 255, .2) 20%, rgba(214, 251, 255, .76) 42%, rgba(130, 215, 255, .2) 64%);
  background-size: 250% 100%;
  animation: liveSkeleton 1.5s ease-in-out infinite;
}
@keyframes liveSkeleton {
  from { background-position: 100% 0; }
  to { background-position: -130% 0; }
}
.state-card {
  max-width: 670px;
  margin: 50px auto 0;
  padding: 20px 18px;
  color: #dffaff;
  text-align: center;
  border: 1px solid rgba(150, 225, 255, .48);
  border-radius: 12px;
  background: rgba(8, 38, 157, .7);
}
@media screen and (max-width: 375px) {
  .partMeeting-container .main { padding-right: 14px; padding-left: 14px; }
  .photo-card { min-height: 114px; margin-bottom: 12px; }
  .opening-card { min-height: 168px; }
  .opening-card .card-content { min-height: 168px; padding-top: 24px; padding-bottom: 24px; }
  .card-content { min-height: 114px; padding: 14px 12px; }
  .card-content h2 { margin-bottom: 12px; font-size: 21px; }
  .opening-card .card-content h2 { margin-bottom: 18px; font-size: 28px; }
  .card-meta { font-size: 10px; }
  .card-meta-top { gap: 14px; margin-bottom: 6px; }
  .card-meta .van-icon { margin-right: 3px; font-size: 12px; }
  .skeleton-card { height: 114px; margin-bottom: 12px; }
  .skeleton-title { margin-top: 29px; }
}
</style>
